/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {
  Box,
  ButtonBase,
  Card,
  FormControl,
  FormControlLabel,
  MenuItem,
  menuItemClasses,
  PopoverOrigin,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import SubTabsComponent from '@components/subTabs/subTabs';
import CardComponent from '@components/card/CardComponent';
import CollapsibleTable from '../collapsible-table/CollapsibleTable';
import RolesComponent from '../../modules-menu/roles-component/RolesComponent';
import UserGroups from '../../modules-menu/user-groups/UserGroups';
import ModuleSearchPage from '../../modules-menu/modules-search-page/ModuleSearchPage';
import EncryptUtils from 'src/utils/EncryptUtils';
import {Buffer} from 'buffer';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {useSnackbar} from 'notistack';
import {
  BASE_DEMOGRAPHIC_ID,
  BASE_LEGACY_APP,
  BASE_MENU_ITEM,
  BASE_PROCEDURE_ID,
  BASE_RECORD_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  BASE_SPECIMEN_NUMBER,
  BASE_SPECIMEN_NUMBER_ID,
  BASE_SPECIMEN_TYPE,
  LMS_TYPE
} from 'src/routes/BaseRoute';
import FormConstants from '@shared/constants/FormConstants';
import {ButtonsDiv} from './TabComponentStyles';
import {
  changeStatusForDownloadedFiles,
  createAuditLog,
  getReportsFileData,
  syncUsers
} from '@shared/services/service-handlers/PrivateService';
import ClinicalNewReport from '@components/clincal_reports/ClinicalNewReport';
import JSZip from 'jszip';
import {saveAs} from 'file-saver';
import {useSelectedDocumentContext} from '@context/SelectedDocumentContext';
import {useSelectedDicomContext} from '@context/SelectedDicomContext';
import {
  AddButtonDiv,
  AddCMSButtonDiv
} from '../../modules-menu/purge-legal-hold/PurgeAndLegalHoldComponentStyle';
import AuthUtils from 'src/utils/AuthUtils';
import DocumentsComponent from '@components/documents/DocumentsComponent';
import IsBHDialog from '@components/dialog/isBH-dialog/IsBHDialog';
import VitalsComponent from '@components/vitals/VitalsComponent';
import GrowthChartWrapper from '@components/growth-chart/GrowthChartWrapper';
import {LoadingButton} from '@mui/lab';
import {useTheme} from '@mui/material/styles';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import Grid from '@mui/system/Unstable_Grid/Grid';
import {
  MainDocViewContainer,
  Text
} from '@components/documents/DocumentsComponentStyles';
import SingleDocViewer from '@components/docViewer/SingleDocViewer';
import {environment} from '@shared/config/environment';
import {
  ClinicalDocumentContainerGrid,
  ClinicalDocumentWrapperGrid
} from '@components/clincal_reports/ClinicalNewReportStyles';
import ClinicalReportDocument from '@components/clinical-report-documents/ClinicalReportDocument';
import ClinicalReportDicom from '@components/clinical-report-dicom/ClinicalReportDicom';
import {useAppContext} from '@context/AppContext';
import {useModuleContext} from '@context/ModuleContext';
import {usePopover} from '@components/custom-popover';
import Iconify from 'src/minimal-components/iconify';
import CustomPopover from 'src/minimal-components/custom-popover';
import Popover from '@mui/material/Popover';
import {getPosition} from '@components/custom-popover/utils';
import {StyledArrow} from '@components/custom-popover/styles';
import InfoIcon from '@mui/icons-material/Info';
import {GridEventListener} from '@mui/x-data-grid-premium';
import SubTabsComponentLMS from '@components/subTabs/subTabsLMS';

interface TabsComponentProps {
  sectionUIData: any;
  sectionRowsData: any;
  onRowClick?: any;
  module?: any;
  sub_module?: any;
  patient_id?: string;
  legacyApp?: string;
  unique_id?: string;
  selectedDropdownValue?: string;
  isConfirmed?: boolean;
  setIsConfirmed?: any;
  procedure_type?: string;
  accession_number?: string;
  handleAddNewRecord?: (data: any) => void;
  handleAddNewCMSRecord?: (data: any, module: string) => void;
  handleDeleteLegalHold?: (data: any) => void;
  handleEditUser?: (data: any) => void;
  handleDeleteUser?: (data: any) => void;
  // eslint-disable-next-line react/boolean-prop-naming
  apiLoader?: boolean;
  isLoading?: boolean;
  ParentLegacyValue?: string;
  handleActiveTabChange?: (data: any) => void;
  growthChartType?: string;
  specimen_number?: any;
  specimen_number_id?: any;
  specimen_type?: any;
  procedure_id?: any;
  demographic_id?: any;
  user_access_module?: any;
}

const TabsComponentLMS = (props: TabsComponentProps): React.ReactElement => {
  const theme = useTheme();
  const {
    sectionUIData,
    sectionRowsData,
    module,
    sub_module,
    selectedDropdownValue,
    isConfirmed,
    setIsConfirmed,
    handleAddNewRecord,
    handleAddNewCMSRecord,
    handleDeleteLegalHold,
    handleEditUser,
    handleDeleteUser,
    apiLoader,
    ParentLegacyValue,
    handleActiveTabChange,
    growthChartType,
    isLoading,
    procedure_type,
    accession_number,
    specimen_type,
    specimen_number,
    demographic_id,
    procedure_id
  } = props;
  const {
    appState: {applicationName, hospitalId}
  } = useAppContext();
  const {
    moduleState: {isBH, isBHReason}
  } = useModuleContext();
  const popover = usePopover();
  const [tabsSubSecData, setTabsSubSecData] = React.useState<any>();
  const [currentTab, setCurrentTab] = React.useState<string>('');
  const [currentradio, setCurrentRadio] = React.useState<string>('');
  const location = useLocation();
  const {t} = useTranslation();
  const {clearSelectedDocumentData} = useSelectedDocumentContext();
  const {clearSelectedDicomData} = useSelectedDicomContext();
  const menuItem = new URLSearchParams(location?.search).get(BASE_MENU_ITEM);
  const recordId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const navigate = useNavigate();
  const {style, anchorOrigin, transformOrigin} = getPosition('top-right');
  const [userGroupsync, setSyncUserGroupData] = React.useState(false);
  const [usersync, setSyncUsers] = React.useState(false);
  const [refreshPage, setRefreshPage] = React.useState<boolean>(false);
  const [refreshUserGroup, setRefreshUserGroup] =
    React.useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const locationState = useLocation();
  const {enqueueSnackbar} = useSnackbar();
  const [buttonLoader, setButtonLoader] = React.useState({
    download: false,
    delete: false,
    regenerate: false
  });
  const [downloadStatus, setDownloadStatus] = React.useState<string>('');
  const [reportsButtonLoader, setIsReportsButtonLoader] =
    React.useState<boolean>(false);
  const [selectedReportsData, setSelectedReportsData] = React.useState<any>([]);
  const [openIsBHDialog, setOpenIsBHDialog] = React.useState<boolean>(false);
  const [triggerFunction, setTriggerFunction] = React.useState<any>(null);
  const onUserGroupsClick = () => {
    setRefreshUserGroup(!refreshUserGroup);
  };
  const params = new URLSearchParams(location.search);
  const section = params.get('section');
  const subsection = params.get('subsection');
  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
  const [rowsdatarecord, setrowsdatarecord] = React.useState<any>([]);
  const [shoulddisplaymetainfo, setShoulddisplaymetainfo] =
    React.useState<boolean>(false);
  const [docDownloadData, setDocDownloadData] = React.useState<string[] | null>(
    []
  );
  const [limite, setLimit] = React.useState<number>(0);
  const [offset, setOffset] = React.useState<number>(0);
  const [pageSize, setPageSize] = React.useState<number>(0);
  const [openning, setopenning] = React.useState<boolean>(false);
  const [refreshFilter, setRfreshFilter] = React.useState<boolean>(false);
  const [deleteDocument, setDeleteDocument] = React.useState<boolean>(false);

  const {
    DOWNLOAD_REPORTS_TO_CLIENT_BROWSER,
    UPLOAD_REPORTS_TO_CENTRAL_PLACE,
    UPLOAD_REPORTS_TO_CENTRAL_PLACE_TYPE,
    IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED
  } = environment || [];

  const validUploadTypes = ['SFTP', 'AZURE_BLOB_STORAGE', 'SHAREPOINT'];

  const isDownloadDisabled =
    (DOWNLOAD_REPORTS_TO_CLIENT_BROWSER && UPLOAD_REPORTS_TO_CENTRAL_PLACE) || // Both true (invalid)
    (!DOWNLOAD_REPORTS_TO_CLIENT_BROWSER && !UPLOAD_REPORTS_TO_CENTRAL_PLACE); // Both false (invalid)

  const isUploadTypeInvalid =
    UPLOAD_REPORTS_TO_CENTRAL_PLACE &&
    (!UPLOAD_REPORTS_TO_CENTRAL_PLACE_TYPE ||
      !validUploadTypes.includes(UPLOAD_REPORTS_TO_CENTRAL_PLACE_TYPE));

  React.useEffect(() => {
    const updateTabFromUrl = () => {
      // Assuming 'section' is your query parameter for tabs
      if (module === FormConstants.MODULE.COURSE_CATALOG && section) {
        setCurrentTab(section);
        if (handleActiveTabChange) {
          handleActiveTabChange(section);
        }
      } else if (
        module === FormConstants.MODULE.PRE_POST_LEARNING &&
        subsection
      ) {
        setCurrentTab(subsection);
        if (handleActiveTabChange) {
          handleActiveTabChange(subsection);
        }
      } else if (module === FormConstants.MODULE.SETTINGS && subsection) {
        setCurrentTab(subsection);
        if (handleActiveTabChange) {
          handleActiveTabChange(subsection);
        }
      }
    };

    updateTabFromUrl();
  }, [section, subsection]);

  const onReportsChange = () => {
    setIsReportsButtonLoader(!reportsButtonLoader);
  };

  React.useEffect(() => {
    if (
      (module === FormConstants.MODULE.USER_ACCESS ||
        module === FormConstants.MODULE.AUDIT_TRAILS ||
        module === FormConstants.MODULE.AUDIT_LOGS ||
        module === FormConstants.MODULE.PURGE_AND_LEGAL_HOLD) &&
      // ||
      // (module === FormConstants.MODULE.PHARMACY && !sub_module)
      searchParams
    ) {
      let searchParam =
        locationState.search.split('?')?.[1]?.split('=')?.[1] ||
        locationState.search.split('?')?.[1]?.split('=')?.[0];
      if (
        searchParam === FormConstants.MODULE.PATIENT_REPORT_LOG ||
        searchParam === FormConstants.MODULE.USER_REPORT_LOG ||
        searchParam === FormConstants.MODULE.USER_ACCESS_LOGS ||
        searchParam === FormConstants.MODULE.PHARMACY
      ) {
        setSearchParams('');
      } else {
        if (searchParam === FormConstants.MENU_ITEM.USER_ACCESS) {
          searchParam = FormConstants.SCREENS.USERS;
        }
        setCurrentTab(searchParam);
        setSearchParams(searchParam);
      }

      const selectedTabData = sectionUIData?.sub_sections?.find((item: any) => {
        return item.name === searchParam;
      });

      setTabsSubSecData(selectedTabData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshPage, refreshUserGroup]);

  React.useEffect(() => {
    if (module === FormConstants.SCREENS.PATIENT_ACCOUNTING) {
      setTabsSubSecData(sectionUIData?.sub_sections?.[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderCard = (subSectionData: any) => {
    return (
      <CardComponent
        fields={subSectionData?.fields}
        data={[]}
        recordId={recordId}
        specimen_number_id={props?.specimen_number_id}
        specimen_number={props?.specimen_number}
        procedure_id={props?.procedure_id}
        demographic_id={props?.demographic_id}
        columns_per_row={subSectionData?.columns}
        is_border_required={true}
        is_space_needed_between_label_value={false}
        is_colon_needed={true}
        module={props?.module}
        sub_module={props?.sub_module}
        sectionUIData={subSectionData}
        procedure_type={procedure_type}
        accession_number={accession_number}
      />
    );
  };
  const handleCellClick: GridEventListener<'cellClick'> = params => {
    const colList = sectionUIData?.other_results;
    // console.log('params', params, colList);
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]:
        params?.row?.PatientID ||
        params?.row?.LegacyMRN ||
        params?.row?.UserID ||
        params?.id,
      [BASE_LEGACY_APP]: params?.row?.LegacyApp,
      [BASE_SPECIMEN_NUMBER]: params?.row?.SpecimenNumber,
      [BASE_SPECIMEN_NUMBER_ID]: params?.row?.SpecimenID,
      [BASE_SPECIMEN_TYPE]: params?.row?.OrderType,
      [BASE_DEMOGRAPHIC_ID]: params?.row?.DemographicID,
      [BASE_PROCEDURE_ID]: params?.row?.ProcedureID
    });
    // for (const field of colList.fields) {
    //   if (params?.field === field.data_column && field?.is_clickable) {
    //     AuthUtils.setAuditIdentifier(params?.value);
    //     AuthUtils.setAuditIdentifierType(params?.colDef?.headerName);
    //     AuthUtils.setAuditLegacyApp(params?.row?.LegacyApp);

    //     const url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${props?.module}/${BASE_ROUTE_SUB_MODULE}?${PARAMS_KEY}=${paramsKey}`;
    //     // if (props?.menuItem) {
    //     //   url += `&${BASE_MENU_ITEM}=${props.menuItem}`;
    //     // }
    //     console.log('url', url);
    //     // navigate(url);
    //   }
    // }
  };
  const handleTabChange = (tabValue: string) => {
    setCurrentTab(tabValue);
    if (
      handleActiveTabChange &&
      (growthChartType?.length ||
        (module === FormConstants.MODULE.CLINICAL &&
          sub_module === FormConstants.SUB_MODULE.REPORTS))
    ) {
      handleActiveTabChange(tabValue);
    }
    if (module === FormConstants.MODULE.COURSE_CATALOG) {
      if (handleActiveTabChange) {
        handleActiveTabChange(tabValue);
      }
    }
    if (module === FormConstants.MODULE.PRE_POST_LEARNING) {
      if (handleActiveTabChange) {
        handleActiveTabChange(tabValue);
      }
    }
    if (module === FormConstants.MODULE.SETTINGS) {
      if (handleActiveTabChange) {
        handleActiveTabChange(tabValue);
      }
    }

    if (
      module === FormConstants.MODULE.USER_ACCESS ||
      module === FormConstants.MODULE.AUDIT_LOGS ||
      module === FormConstants.MODULE.AUDIT_TRAILS ||
      module === FormConstants.MODULE.PURGE_AND_LEGAL_HOLD ||
      (module === FormConstants.MODULE.PHARMACY && !sub_module)
    ) {
      const resetList = ['audit-trails', 'patient_search', 'audit_logs'];
      if (
        module === FormConstants.MODULE.PHARMACY &&
        resetList.includes(tabValue)
      ) {
        setSearchParams('');
      } else {
        setSearchParams(tabValue);
      }
    }
    const selectedTabData = sectionUIData?.sub_sections?.find(
      (item: any) => item.name === tabValue
    );

    setTabsSubSecData(selectedTabData);
    if (
      module === FormConstants.MODULE.AUDIT_TRAILS ||
      module === FormConstants.MODULE.AUDIT_LOGS ||
      module === FormConstants.MODULE.PURGE_AND_LEGAL_HOLD ||
      (module === FormConstants.MODULE.PHARMACY && tabValue === 'user-log')
    ) {
      navigate(
        `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${props?.module}?${BASE_MENU_ITEM}=${tabValue}`,
        {
          state: {}
        }
      );
    }
    if (
      module === FormConstants.MODULE.CLINICAL &&
      sub_module === FormConstants.SUB_MODULE.REPORTS &&
      tabValue !== FormConstants.REPORTS_SCREENS.DOCUMENT_VIEWER_CLINICAL &&
      tabValue !== FormConstants.REPORTS_SCREENS.DICOM_VIEWER_CLINICAL
    ) {
      clearSelectedDocumentData({data: []});
      clearSelectedDicomData({data: []});
    }
  };

  const getBase64Data = (bufferData: any) => {
    const base64Data: any = [];
    bufferData.forEach((item: any) => {
      base64Data.push({
        uri: `data:application/pdf;base64,${Buffer.from(
          item.data.data
        ).toString('base64')}`,
        name: item.fileName
      });
    });
    return base64Data;
  };

  // const handleDownloadDocuments = async (
  //   isBHType?: string,
  //   isBHMessage?: string
  // ) => {
  //   try {
  //     if (selectedReportsData.length) {
  //       const id: any = [];
  //       selectedReportsData.forEach((data: any) => {
  //         id.push(data.ID);
  //       });

  //       const fileSql = sectionUIData?.sub_sections.find(
  //         (item: any) => item.file_sql
  //       );

  //       const auditObj = {
  //         is_audit: true,
  //         audit_event_description: FormConstants.COMMON.DOWNLOADED_REPORTS
  //       };

  //       const payload: any = {
  //         ids: id,
  //         fileSql: fileSql.file_sql,
  //         action: FormConstants.REPORTS_SCREENS.DOWNLOAD,
  //         audit_sub_module_identifier: id,
  //         audit_identifier: AuthUtils.getAuditIdentifier(),
  //         audit_identifier_type: AuthUtils.getAuditIdentifierType(),
  //         audit_legacy_app: AuthUtils.getAuditLegacyApp(),
  //         isBH: isBHType === 'View_Restricted' ? 1 : 0,
  //         isBH_Message: isBHMessage ?? ''
  //       };

  //       payload.sql_data = auditObj;

  //       const encryptPayload = EncryptUtils.encryptedData(payload);

  //       setButtonLoader(prevState => ({
  //         ...prevState,
  //         download: true
  //       }));
  //       const fileDownloadData = await getReportsFileData({
  //         tk: encryptPayload
  //       });

  //       // Create a Blob from the response data
  //       // const blob = new Blob([fileDownloadData], {type: 'application/pdf'});

  //       // Create an anchor element to trigger the download
  //       const url = URL.createObjectURL(fileDownloadData);
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.setAttribute('download', 'reports.pdf');
  //       document.body.appendChild(link);
  //       link.click();

  //       // Cleanup
  //       link.parentNode?.removeChild(link);
  //       URL.revokeObjectURL(url);
  //       //  const {buffer_data: bufferData} = fileDownloadData;

  //       //  const base64Res = getBase64Data(bufferData);

  //       //  if (base64Res.length) {
  //       //    if (base64Res.length === 1) {
  //       //      const a = document.createElement('a');
  //       //      a.setAttribute('href', `${base64Res?.[0]?.uri}`);
  //       //      a.setAttribute('download', `${base64Res?.[0]?.name}`);
  //       //      a.click();
  //       //    } else {
  //       //      const zip = new JSZip();
  //       //      base64Res.map((item: any, index: any) => {
  //       //        // eslint-disable-next-line no-unsafe-optional-chaining
  //       //        const [, fileData] = item?.uri?.split(',');
  //       //        zip.file(`${item?.name}`, fileData, {
  //       //          base64: true
  //       //        });
  //       //      });
  //       //      zip.generateAsync({type: 'blob'}).then(function (content) {
  //       //        saveAs(content, `Reports-Documents.zip`);
  //       //      });
  //       //    }

  //       //    try {
  //       //      const payloadForChangeStatus: any = {
  //       //        fileSql: fileSql.file_sql,
  //       //        fileDetails: fileDownloadData.file_details,
  //       //        isBH: isBHType === 'View_Restricted' ? 1 : 0,
  //       //        isBH_Message: isBHMessage ?? ''
  //       //      };

  //       //      const encryptPayloadForChangeStatus = EncryptUtils.encryptedData(
  //       //        payloadForChangeStatus
  //       //      );

  //       //      const {message: changeStatusMessage} =
  //       //        await changeStatusForDownloadedFiles({
  //       //          tk: encryptPayloadForChangeStatus
  //       //        });

  //       //      if (changeStatusMessage) {
  //       //        setButtonLoader(prevState => ({
  //       //          ...prevState,
  //       //          download: false
  //       //        }));
  //       //        enqueueSnackbar(changeStatusMessage, SnackBarConfig.getSuccess());
  //       //      }
  //       //    } catch (error) {
  //       //      setButtonLoader((prevState: any) => ({
  //       //        ...prevState,
  //       //        download: false
  //       //      }));
  //       //      const {message}: any = error;
  //       //      onReportsChange();
  //       //      setSelectedReportsData([]);
  //       //      enqueueSnackbar(message, SnackBarConfig.getError());
  //       //    }
  //       //  }
  //       setButtonLoader((prevState: any) => ({
  //         ...prevState,
  //         download: false
  //       }));
  //     }
  //     setDeleteDocument(true);
  //     onReportsChange();
  //     setSelectedReportsData([]);
  //   } catch (error) {
  //     setButtonLoader((prevState: any) => ({
  //       ...prevState,
  //       download: false
  //     }));

  //     if (error instanceof Blob) {
  //       error
  //         .text()
  //         .then(err => {
  //           const errParse = JSON.parse(err);
  //           onReportsChange();
  //           setSelectedReportsData([]);
  //           enqueueSnackbar(errParse.message, SnackBarConfig.getError());
  //         })
  //         .catch(blobError => {
  //           console.error('Failed to read blob:', blobError);
  //         });
  //     } else {
  //       const {message}: any = error;
  //       onReportsChange();
  //       setSelectedReportsData([]);
  //       enqueueSnackbar(message, SnackBarConfig.getError());
  //     }
  //   }
  // };

  const logReportsData = (dataObj: any) => {
    let eventDescription = props.module ? props.module + ' -> ' : '';

    if (props.sub_module) {
      eventDescription += `${props.sub_module}`;
    }

    if (dataObj?.sql_data?.audit_event_description) {
      eventDescription += ` -> ${dataObj?.sql_data?.audit_event_description}`;
    } else if (dataObj?.name) {
      eventDescription += ` -> ${dataObj?.name}`;
    }

    const data = {
      module: props.module,
      sub_module:
        (props.sub_module ?? '') +
        ` -> ${dataObj?.sql_data?.audit_event_description}`,
      sub_module_identifier: JSON.stringify(dataObj.ids),
      application_name: applicationName,
      procedure_type,
      isBH_selected: !isBHReason?.length && isBH == false ? true : isBH,
      isBH_reason: isBHReason,
      event_description: eventDescription,
      audit_identifier: AuthUtils.getAuditIdentifier(),
      audit_identifier_type: AuthUtils.getAuditIdentifierType(),
      audit_legacy_app: AuthUtils.getAuditLegacyApp()
    };
    createAuditLog(props.module, data);
  };

  const handleDownloadDocuments = async (
    isBHType?: string,
    isBHMessage?: string
  ) => {
    try {
      if (selectedReportsData.length) {
        const id: any = [];
        selectedReportsData.forEach((data: any) => {
          id.push(data.ID);
        });

        const fileSql = sectionUIData?.sub_sections.find(
          (item: any) => item.file_sql
        );

        const auditObj = {
          is_audit: true,
          audit_event_description: FormConstants.COMMON.DOWNLOADED_REPORTS
        };

        const payload: any = {
          ids: id,
          fileSql: fileSql.file_sql,
          action: FormConstants.REPORTS_SCREENS.DOWNLOAD,
          audit_sub_module_identifier: id,
          audit_identifier: AuthUtils.getAuditIdentifier(),
          audit_identifier_type: AuthUtils.getAuditIdentifierType(),
          audit_legacy_app: AuthUtils.getAuditLegacyApp(),
          isBH: isBHType === 'View_Restricted' ? 1 : 0,
          isBH_Message: isBHMessage ?? '',
          downloadMode: DOWNLOAD_REPORTS_TO_CLIENT_BROWSER
            ? 'CLIENT_BROWSER'
            : UPLOAD_REPORTS_TO_CENTRAL_PLACE_TYPE
        };

        payload.sql_data = auditObj;

        const encryptPayload = EncryptUtils.encryptedData(payload);

        setButtonLoader(prevState => ({
          ...prevState,
          download: true
        }));
        const response = await getReportsFileData({
          tk: encryptPayload
        });
        logReportsData(payload);

        if (
          !DOWNLOAD_REPORTS_TO_CLIENT_BROWSER &&
          UPLOAD_REPORTS_TO_CENTRAL_PLACE
        ) {
          // 1 0
          if (response.status === 202) {
            const text = await response.data.text();
            const {message} = JSON.parse(text);
            enqueueSnackbar(message, SnackBarConfig.getSuccess());
          }
        } else if (
          DOWNLOAD_REPORTS_TO_CLIENT_BROWSER &&
          !UPLOAD_REPORTS_TO_CENTRAL_PLACE
        ) {
          // 0 1
          const fileDownloadData = response.data;
          const headers = response.headers;
          let filename = 'reports.pdf'; // Default filename if none is provided

          // if content disposition header is not sent from server, or if it is blocked by client then corrupt file will be downloaded because of file name
          const contentDisposition = headers['content-disposition'];

          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(
              /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            );
            if (filenameMatch != null && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, ''); // Remove quotes around filename
            }
          }

          // Create a Blob from the response data
          // const blob = new Blob([fileDownloadData], {type: 'application/pdf'});

          // Create an anchor element to trigger the download
          const url = URL.createObjectURL(fileDownloadData);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();

          // Cleanup
          link.parentNode?.removeChild(link);
          URL.revokeObjectURL(url);
        } else {
          // 1 1
          const fileDownloadData = response.data;
          const headers = response.headers;
          let filename = 'reports.pdf'; // Default filename if none is provided

          // if content disposition header is not sent from server, or if it is blocked by client then corrupt file will be downloaded because of file name
          const contentDisposition = headers['content-disposition'];

          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(
              /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            );
            if (filenameMatch != null && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, ''); // Remove quotes around filename
            }
          }

          // Create a Blob from the response data
          // const blob = new Blob([fileDownloadData], {type: 'application/pdf'});

          // Create an anchor element to trigger the download
          const url = URL.createObjectURL(fileDownloadData);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();

          // Cleanup
          link.parentNode?.removeChild(link);
          URL.revokeObjectURL(url);
          const message = 'Saving to a network location was successful.';
          enqueueSnackbar(
            // t('PRIVATE.REPORTS.RECORDS_DELETED', {ns: 'private'}),
            message,
            SnackBarConfig.getSuccess()
          );
        }

        try {
          const payloadForChangeStatus: any = {
            fileSql: fileSql.file_sql,
            fileDetails: id,
            isBH: isBHType === 'View_Restricted' ? 1 : 0,
            isBH_Message: isBHMessage ?? ''
          };

          const encryptPayloadForChangeStatus = EncryptUtils.encryptedData(
            payloadForChangeStatus
          );

          const {message: changeStatusMessage} =
            await changeStatusForDownloadedFiles({
              tk: encryptPayloadForChangeStatus
            });

          if (changeStatusMessage) {
            setButtonLoader(prevState => ({
              ...prevState,
              download: false
            }));
            enqueueSnackbar(changeStatusMessage, SnackBarConfig.getSuccess());
          }
        } catch (error) {
          setButtonLoader((prevState: any) => ({
            ...prevState,
            download: false
          }));
          const {message}: any = error;
          onReportsChange();
          setSelectedReportsData([]);
          enqueueSnackbar(message, SnackBarConfig.getError());
        }
        setButtonLoader((prevState: any) => ({
          ...prevState,
          download: false
        }));
      }

      setDeleteDocument(true);
      onReportsChange();
      setSelectedReportsData([]);
    } catch (error: any) {
      setButtonLoader((prevState: any) => ({
        ...prevState,
        download: false
      }));

      if (error instanceof Blob) {
        error
          .text()
          .then(err => {
            const errParse = JSON.parse(err);
            onReportsChange();
            setSelectedReportsData([]);
            enqueueSnackbar(errParse.message, SnackBarConfig.getError());
          })
          .catch(blobError => {
            console.error('Failed to read blob:', blobError);
          });
      } else {
        const text = await error.data.text();
        const errorJson = JSON.parse(text);
        // const {message}: any = error;
        onReportsChange();
        setSelectedReportsData([]);
        enqueueSnackbar(errorJson.message, SnackBarConfig.getError());
      }
    }
  };

  const handleDeleteDocuments = async () => {
    setDeleteDocument(true);
    try {
      if (selectedReportsData.length) {
        const id: any = [];
        selectedReportsData.forEach((data: any) => {
          id.push(data.ID);
        });

        const fileSql = sectionUIData?.sub_sections.find(
          (item: any) => item.file_sql
        );
        const auditObj = {
          is_audit: true,
          audit_event_description: FormConstants.COMMON.DELETED_REPORTS
        };

        const payload: any = {
          ids: id,
          fileSql: fileSql.file_sql,
          action: FormConstants.REPORTS_SCREENS.DELETE,
          audit_sub_module_identifier: id,
          audit_identifier: AuthUtils.getAuditIdentifier(),
          audit_identifier_type: AuthUtils.getAuditIdentifierType(),
          audit_legacy_app: AuthUtils.getAuditLegacyApp()
        };

        payload.sql_data = auditObj;

        const encryptPayload = EncryptUtils.encryptedData(payload);

        setButtonLoader(prevState => ({
          ...prevState,
          delete: true
        }));

        await getReportsFileData({tk: encryptPayload});

        logReportsData(payload);

        setButtonLoader(prevState => ({
          ...prevState,
          delete: false
        }));

        onReportsChange();
        enqueueSnackbar(
          t('PRIVATE.REPORTS.RECORDS_DELETED', {ns: 'private'}),
          SnackBarConfig.getSuccess()
        );
        setSelectedReportsData([]);
      }
    } catch (error) {
      setButtonLoader(prevState => ({
        ...prevState,
        delete: false
      }));
      const {message}: any = error;
      onReportsChange();
      setSelectedReportsData([]);
      enqueueSnackbar(message, SnackBarConfig.getError());
    }
  };

  const handleRegenerateDocuments = async (
    isBHType?: string,
    isBHMessage?: string
  ) => {
    try {
      if (selectedReportsData.length) {
        const id: any = [];
        selectedReportsData.forEach((data: any) => {
          id.push(data.ID);
        });

        const fileSql = sectionUIData?.sub_sections.find(
          (item: any) => item.file_sql
        );

        const auditObj = {
          is_audit: true,
          audit_event_description: FormConstants.COMMON.REGENERATED_REPORTS
        };

        const payload: any = {
          ids: id,
          fileSql: fileSql.file_sql,
          action: FormConstants.REPORTS_SCREENS.REGENERATE,
          audit_sub_module_identifier: id,
          audit_identifier: AuthUtils.getAuditIdentifier(),
          audit_identifier_type: AuthUtils.getAuditIdentifierType(),
          audit_legacy_app: AuthUtils.getAuditLegacyApp(),
          isBH: isBHType === 'View_Restricted' ? 1 : 0,
          isBH_Message: isBHMessage ?? ''
        };

        payload.sql_data = auditObj;

        const encryptPayload = EncryptUtils.encryptedData(payload);

        setButtonLoader(prevState => ({
          ...prevState,
          regenerate: true
        }));

        await getReportsFileData({tk: encryptPayload});
        logReportsData(payload);

        setButtonLoader(prevState => ({
          ...prevState,
          regenerate: false
        }));

        onReportsChange();
        enqueueSnackbar(
          t('PRIVATE.REPORTS.RECORDS_REGENERATED', {ns: 'private'}),
          SnackBarConfig.getSuccess()
        );
        setSelectedReportsData([]);
      }
      setDeleteDocument(true);
    } catch (error) {
      setButtonLoader(prevState => ({
        ...prevState,
        regenerate: false
      }));
      const {message}: any = error;
      onReportsChange();
      enqueueSnackbar(message, SnackBarConfig.getError());
    }
  };

  const checkIsBHDialog = (triggeredFunc: string) => {
    const permissions = AuthUtils.getPermissions();
    const permissionExisted = permissions?.some(
      (ele: any) =>
        ele.object === props.module &&
        ele.function === FormConstants.IS_BH.VIEW_RESTRICTED_DATA
    );

    if (permissionExisted) {
      switch (triggeredFunc) {
        case 'download':
          return handleDownloadDocuments();
        case 'generate':
          return handleRegenerateDocuments();
        default:
          break;
      }
    } else {
      const foundIsBH = selectedReportsData.find((item: any) => {
        if (item?.IsBH) {
          return item?.IsBH.toLowerCase() === 'yes' || undefined;
        }
      });
      if (foundIsBH) {
        setTriggerFunction(triggeredFunc);
        setOpenIsBHDialog(true);
      } else {
        switch (triggeredFunc) {
          case 'download':
            return handleDownloadDocuments();
          case 'generate':
            return handleRegenerateDocuments();
          default:
            break;
        }
      }
    }
  };

  const renderButtons = () => {
    return (
      <ButtonsDiv style={{marginTop: '1rem'}}>
        {isDownloadDisabled || isUploadTypeInvalid ? (
          // Wrapping the button inside Tooltip when there's an error
          <Tooltip
            title={
              isDownloadDisabled
                ? 'No valid download option is enabled'
                : 'Missing or Invalid Upload Type'
            }>
            <span>
              <LoadingButton
                disabled={true}
                type="submit"
                variant="contained"
                loading={buttonLoader.download}
                sx={{
                  mr: 1,
                  bgcolor: theme.palette.primary.dark
                }}>
                {t('PRIVATE.REPORTS.DOWNLOAD', {ns: 'private'})}
                <InfoIcon color="error" sx={{ml: 1}} />
              </LoadingButton>
            </span>
          </Tooltip>
        ) : (
          // Normal button when there's no error
          <LoadingButton
            disabled={
              !selectedReportsData.length ||
              selectedReportsData.length > 1 ||
              buttonLoader.delete ||
              buttonLoader.regenerate ||
              !openning
                ? true
                : false
            }
            onClick={() => checkIsBHDialog('download')}
            type="submit"
            variant="contained"
            loading={buttonLoader.download}
            sx={{
              mr: 1,
              bgcolor: theme.palette.primary.dark
            }}>
            {DOWNLOAD_REPORTS_TO_CLIENT_BROWSER
              ? `${t('PRIVATE.REPORTS.DOWNLOAD_TO_LOCAL', {ns: 'private'})}`
              : UPLOAD_REPORTS_TO_CENTRAL_PLACE
                ? UPLOAD_REPORTS_TO_CENTRAL_PLACE_TYPE === 'SFTP'
                  ? `${t('PRIVATE.REPORTS.DOWNLOAD_TO_SFTP', {ns: 'private'})}`
                  : UPLOAD_REPORTS_TO_CENTRAL_PLACE_TYPE ===
                      'AZURE_BLOB_STORAGE'
                    ? `${t('PRIVATE.REPORTS.DOWNLOAD_TO_AZURE_BLOB_STORAGE', {ns: 'private'})}`
                    : UPLOAD_REPORTS_TO_CENTRAL_PLACE_TYPE === 'SHAREPOINT'
                      ? `${t('PRIVATE.REPORTS.DOWNLOAD_TO_SHAREPOINT', {ns: 'private'})}`
                      : `${t('PRIVATE.REPORTS.DOWNLOAD_TO_AZURE_BLOB_STORAGE', {ns: 'private'})}`
                : `${t('PRIVATE.REPORTS.DOWNLOAD_TO_CENTRAL', {ns: 'private'})}`}
          </LoadingButton>
        )}

        <LoadingButton
          disabled={
            !selectedReportsData.length ||
            buttonLoader.download ||
            buttonLoader.regenerate ||
            !openning
              ? true
              : false
          }
          type="submit"
          loading={buttonLoader.delete}
          onClick={() => handleDeleteDocuments()}
          variant="contained"
          // color="error"
          sx={{
            mr: 1,
            bgcolor: theme.palette.primary.lighter
          }}>
          {t('PRIVATE.REPORTS.DELETE', {ns: 'private'})}
        </LoadingButton>
        <LoadingButton
          disabled={
            !selectedReportsData.length ||
            buttonLoader.download ||
            buttonLoader.delete ||
            !openning
              ? true
              : false
          }
          type="submit"
          onClick={() => checkIsBHDialog('generate')}
          variant="contained"
          loading={buttonLoader?.regenerate}
          // color="success"
          sx={{
            mr: 1,
            bgcolor: theme.palette.primary.main
          }}>
          {t('PRIVATE.REPORTS.REGENERATE', {ns: 'private'})}
        </LoadingButton>
        <LoadingButton
          disabled={
            buttonLoader.download ||
            buttonLoader.delete ||
            buttonLoader.regenerate
              ? true
              : false
          }
          type="reset"
          onClick={() => {
            onReportsChange();
            setopenning(true);
            setDeleteDocument(true);
            setRfreshFilter(true);
          }}
          variant="outlined"
          sx={{
            mr: 1,
            bgcolor: theme.palette.primary.light
          }}>
          <p>{t('PRIVATE.REPORTS.REFRESH', {ns: 'private'})}</p>
        </LoadingButton>
        {selectedReportsData.length > 1 && (
          <Typography
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: theme.palette.primary.lighter,
              fontSize: '14px',
              fontWeight: 700
            }}>
            {t('PRIVATE.REPORTS.MULTIPLE_NOT_ALLOWED', {ns: 'private'})}
          </Typography>
        )}
      </ButtonsDiv>
    );
  };

  const onUserGroupClick = (userGroupName: string): any => {
    if (typeof userGroupName === 'string') {
      AuthUtils.setUserAccess(userGroupName);

      navigate(
        // eslint-disable-next-line max-len
        `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${props?.module}?${BASE_MENU_ITEM}=${FormConstants.USER_ACCESS.USER_GROUPS}?${FormConstants.USER_ACCESS.SELECTED_GROUP}=${userGroupName}`,
        {
          state: {}
        }
      );

      onUserGroupsClick();
    }
  };

  const handleGenerateReportBtn = () => {
    setCurrentTab(FormConstants.REPORTS_SCREENS.PREVIOUS_REPORT_TAB);
    setTabsSubSecData(sectionUIData?.sub_sections[0]);
  };

  const deleteLegalHold = (data: any): void => {
    if (handleDeleteLegalHold && typeof handleDeleteLegalHold === 'function') {
      handleDeleteLegalHold(data);
    }
  };

  const editUser = (data: any): void => {
    if (handleEditUser && typeof handleEditUser === 'function') {
      handleEditUser(data);
    }
  };

  const deleteUser = (data: any) => {
    if (handleDeleteUser && typeof handleDeleteUser === 'function') {
      handleDeleteUser(data);
    }
  };

  const renderTabs = (subSectionsData: any, row: any) => {
    const colList = subSectionsData?.sub_sections || [];
    let selectedTabData: any;
    if (currentTab) {
      selectedTabData = tabsSubSecData;
    } else {
      selectedTabData = sectionUIData?.sub_sections?.find(
        (item: any) => item.name === colList?.[0]?.name
      );
    }

    // Filter out tabs based on CDC and WHO
    const filteredColList = colList.filter((item: any) => {
      if (
        growthChartType &&
        growthChartType.length &&
        ((item.name === 'head_circumference' && growthChartType === 'CDC') ||
          (item.name === 'bmi' && growthChartType === 'WHO'))
      ) {
        return false;
      }
      if (item.name === 'settings' && lmstype === 'view') {
        return false;
      }
      if (item.name === 'members' && lmstype === 'view') {
        return false;
      }
      return true;
    });

    const createdByMe = (value: string) => {
      selectedTabData.sql_data = selectedTabData.created_by_me;
      setSelectedReportsData([]);
      setPageSize(0);
      setLimit(0);
      setCurrentRadio(value);
    };

    const createdByAll = (value: string) => {
      selectedTabData.sql_data = selectedTabData.created_by_all;
      setSelectedReportsData([]);
      setPageSize(0);
      setLimit(0);
      setCurrentRadio(value);
    };

    const renderRadioBox = () => {
      return (
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue={() => {
              createdByMe(FormConstants.REPORTS_SCREENS.CREATED_BY_ME);
              return FormConstants.REPORTS_SCREENS.CREATED_BY_ME;
            }}
            name="radio-buttons-group"
            // sx={{margin: '1rem 0 0 1rem'}}
          >
            <FormControlLabel
              value={FormConstants.REPORTS_SCREENS.CREATED_BY_ME}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: theme.palette.primary.lighter,
                      '& .MuiSvgIcon-root': {
                        color: theme.palette.primary.lighter
                      }
                    }
                  }}
                />
              }
              label={FormConstants.REPORTS_SCREENS.ME}
              onClick={() =>
                createdByMe(FormConstants.REPORTS_SCREENS.CREATED_BY_ME)
              }
            />
            <FormControlLabel
              value={FormConstants.REPORTS_SCREENS.CREATED_BY_ALL}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: theme.palette.primary.lighter,
                      '& .MuiSvgIcon-root': {
                        color: theme.palette.primary.lighter
                      }
                    }
                  }}
                />
              }
              label={FormConstants.REPORTS_SCREENS.ALL}
              onClick={() =>
                createdByAll(FormConstants.REPORTS_SCREENS.CREATED_BY_ALL)
              }
            />
          </RadioGroup>
        </FormControl>
      );
    };

    const renderSelectedTabInfo = (
      selectedTabInfo: unknown
    ): React.ReactElement => {
      switch (selectedTabInfo) {
        case FormConstants.DATA_GRID_TYPES.ROLES:
          return <RolesComponent />;

        case FormConstants.DATA_GRID_TYPES.USER_GROUPS:
          return (
            <UserGroups
              refreshTrigger={refreshPage}
              setRefreshPage={setRefreshPage}
              setRefreshUserGroup={setRefreshUserGroup}
              userGroupsync={userGroupsync}
              setUserGroupsync={setSyncUserGroupData}
            />
          );

        case FormConstants.DATA_GRID_TYPES.DATA_GRID:
          return (
            <Box sx={{px: 3}}>
              {(props?.sub_module === FormConstants.REPORTS_SCREENS.REPORTS ||
                props?.module === FormConstants.MODULE.CLINICAL) &&
              selectedTabData.name === FormConstants.REPORTS_SCREENS.TAB
                ? renderRadioBox()
                : null}
              {props.module === FormConstants.MODULE.PRE_POST_LEARNING &&
              selectedTabData.name === 'applicable_to'
                ? renderRadioBox()
                : null}

              <Grid>
                <Card sx={{boxShadow: 5, borderRadius: '8px'}}>
                  <CollapsibleTable
                    refreshFilter={refreshFilter}
                    setRefreshFilter={setRfreshFilter}
                    sectionUIData={selectedTabData}
                    sectionRowsData={rowsdatarecord}
                    module={props?.module}
                    sub_module={props?.sub_module}
                    selectedRowDetails={row}
                    recordId={recordId}
                    setSelectedReportsData={(data: any) => {
                      setSelectedReportsData(data.finrecords);
                      setrowsdatarecord(data.rowsdata);
                      setLimit(data.sizevalue);
                      setOffset(data.pagesize);
                      setPageSize(data.perpage);
                      if (data.finrecords.length > 0) {
                        setopenning(true);
                      } else {
                        setopenning(false);
                      }
                    }}
                    handleDisableCheckBox={true}
                    isReportsButtonLoader={reportsButtonLoader}
                    onCellClick={
                      props.module === FormConstants.MODULE.USER_ACCESS
                        ? onUserGroupClick
                        : null
                    }
                    handleDeleteLegalHold={deleteLegalHold}
                    handleEditUser={editUser}
                    handleDeleteUser={deleteUser}
                    apiLoader={apiLoader}
                    growthChartType={growthChartType}
                    procedure_type={procedure_type}
                    accession_number={accession_number}
                    specimen_number_id={props?.specimen_number_id}
                    specimen_number={props?.specimen_number}
                    procedure_id={props?.procedure_id}
                    demographic_id={props?.demographic_id}
                    limit={pageSize}
                    offset={limite * pageSize}
                    opening={openning}
                    setopening={setopenning}
                    deleteDocument={deleteDocument}
                    radiochangevalue={currentradio}
                    setSyncUsers={setSyncUsers}
                    usersync={usersync}
                    setDeleteDocument={setDeleteDocument}
                    {...(props?.module === FormConstants.MODULE.CLINICAL &&
                    props?.sub_module === FormConstants.SUB_MODULE.VITALS &&
                    selectedTabData?.sub_name ===
                      FormConstants.VITAL_SCREENS.GROWTH_CHART
                      ? {gridHeight: '43vh', minHeight: '43vh'}
                      : {})}
                  />
                </Card>
              </Grid>
              {(props?.sub_module === FormConstants.REPORTS_SCREENS.REPORTS ||
                props?.module === FormConstants.MODULE.CLINICAL) &&
              selectedTabData.name === FormConstants.REPORTS_SCREENS.TAB
                ? renderButtons()
                : null}
            </Box>
          );

        case FormConstants.DATA_GRID_TYPES.CHART:
          return (
            <Grid
              sx={{
                height: '75vh'
              }}>
              <GrowthChartWrapper
                data={selectedTabData?.chart_data}
                sectionUIData={selectedTabData}
                sectionRowsData={[]}
                module={props?.module}
                sub_module={props?.sub_module}
                legacyApp={props?.legacyApp}
                recordId={recordId}
              />
            </Grid>
          );

        default:
          return <div />;
      }
    };
    const SyncUsersData = async () => {
      try {
        const data = await syncUsers(
          {hospitalIds: hospitalId},
          applicationName
        );
        setSyncUsers(false);
      } catch (error) {
        setSyncUsers(false);
      }
    };
    const renderAddNewButton = (text: string): React.ReactElement => {
      return (
        <AddButtonDiv>
          <LoadingButton
            type="submit"
            variant="contained"
            color="success"
            sx={{
              mb: 1.5,
              mr: '0.8vh',
              bgcolor: theme.palette.primary.main
            }}
            onClick={() => {
              if (
                handleAddNewRecord &&
                typeof handleAddNewRecord === 'function'
              ) {
                handleAddNewRecord(menuItem || currentTab);
              }
            }}>
            {text}
          </LoadingButton>
        </AddButtonDiv>
      );
    };
    const renderSyncUsers = (text: string): React.ReactElement => {
      return (
        <AddButtonDiv>
          <LoadingButton
            type="submit"
            variant="contained"
            color="info"
            sx={{
              mb: 1.5,
              mr: '0.8vh',
              bgcolor: theme.palette.info.main
            }}
            loading={usersync}
            onClick={() => {
              setSyncUsers(true);
              SyncUsersData();
            }}>
            {text}
          </LoadingButton>
        </AddButtonDiv>
      );
    };
    const renderSyncUserGroup = (text: string): React.ReactElement => {
      return (
        <AddButtonDiv>
          <LoadingButton
            type="submit"
            variant="contained"
            color="info"
            sx={{
              mb: 1.5,
              mr: '0.8vh',
              bgcolor: theme.palette.info.main
            }}
            onClick={() => {
              setSyncUserGroupData(true);
            }}>
            {text}
          </LoadingButton>
        </AddButtonDiv>
      );
    };
    const renderAddCMSButton = (text: string): React.ReactElement => {
      return (
        <AddCMSButtonDiv>
          <LoadingButton
            type="submit"
            variant="contained"
            color="info"
            sx={{
              mr: '0.8vh'
            }}
            onClick={() => {
              if (
                handleAddNewRecord &&
                typeof handleAddNewRecord === 'function'
              ) {
                handleAddNewRecord(menuItem || currentTab);
              }
            }}>
            {text}
          </LoadingButton>
        </AddCMSButtonDiv>
      );
    };

    const renderDocumentComponent = (item: any) => {
      return (
        <DocumentsComponent
          subModuleUIData={item?.isMultiType ? item : item?.sectionUIData}
          subModuleData={item.sectionValues}
          module={props?.module}
          sub_module={props?.sub_module}
          patient_id={item?.record_id}
          legacyApp={props?.legacyApp}
          unique_id={item?.unique_id}
          ParentLegacyValue={''}
          procedure_type={procedure_type}
          accession_number={accession_number}
        />
      );
    };

    const getDocumentViewerComponent = (item: any) => {
      return (
        <MainDocViewContainer item xs={12}>
          <SingleDocViewer
            sectionUIData={item}
            customDocViewerActions={item?.actions}
            recordId={recordId}
            procedure_type={procedure_type}
            specimen_number={specimen_number}
            specimen_number_id={props?.specimen_number_id}
            procedure_id={props?.procedure_id}
            demographic_id={props?.demographic_id}
            accession_number={accession_number}
            module={props?.module}
            sub_module={props?.sub_module}
            refresh={true}
            docDownloadData={docDownloadData}
            setDocDownloadData={setDocDownloadData}
            shoulddisplaymetainfo={shoulddisplaymetainfo}
            setShoulddisplaymetainfo={setShoulddisplaymetainfo}
            height={'50vh'}
          />
        </MainDocViewContainer>
      );
    };

    const renderVitalComponent = (): React.ReactElement => {
      return (
        <VitalsComponent
          sectionUIData={sectionUIData?.sub_sections[0]}
          sectionRowsData={sectionRowsData}
          ParentLegacyValue={ParentLegacyValue}
        />
      );
    };

    const renderSelectedTabData = (item: any) => {
      if (item.type === FormConstants.DATA_GRID_TYPES.CARD) {
        return renderCard(item);
      } else if (
        item.type === FormConstants.MODULE.PATIENT_REPORT_LOG ||
        item.type === FormConstants.MODULE.USER_REPORT_LOG ||
        item.type === FormConstants.MODULE.USER_ACCESS_LOGS ||
        item.type === FormConstants.PAGE_SECTION_TYPES.TABS
      ) {
        return (
          <TabsComponentLMS
            sectionUIData={item}
            sectionRowsData={[]}
            module={module}
            sub_module={sub_module}
            specimen_number_id={props?.specimen_number_id}
            specimen_number={props?.specimen_number}
            procedure_type={procedure_type}
            procedure_id={props?.procedure_id}
            demographic_id={props?.demographic_id}
            accession_number={accession_number}
          />
        );
      } else if (item.type === FormConstants.PAGE_SECTION_TYPES.DOCUMENTS) {
        return renderDocumentComponent(item);
      } else if (
        item.type === FormConstants.PAGE_SECTION_TYPES.SINGLE_DOCUMENT
      ) {
        return getDocumentViewerComponent(item);
      } else if (
        item.name != FormConstants.PURGE_TERMS.PURGE_SELECTION_LIST &&
        !item?.is_clinical_module_report &&
        item.type === FormConstants.DATA_GRID_TYPES.DATA_GRID
      ) {
        if (
          props?.sub_module === FormConstants.VITAL_SCREENS.VITAL &&
          selectedTabData.name === FormConstants.VITAL_SCREENS.VITAL
        ) {
          return renderVitalComponent();
        } else if (
          props?.sub_module === FormConstants.REPORTS_SCREENS.REPORTS &&
          selectedTabData.name === FormConstants.REPORTS_SCREENS.TAB
        ) {
          return null;
        } else {
          return (
            <CollapsibleTable
              sectionUIData={item}
              sectionRowsData={[]}
              module={props?.module}
              sub_module={props?.sub_module}
              selectedRowDetails={row}
              recordId={recordId}
              onCellClick={handleCellClick}
              handleDeleteLegalHold={deleteLegalHold}
              handleEditUser={editUser}
              handleDeleteUser={deleteUser}
              apiLoader={apiLoader}
              procedure_type={procedure_type}
              accession_number={accession_number}
              specimen_number_id={props?.specimen_number_id}
              specimen_number={props?.specimen_number}
              procedure_id={props?.procedure_id}
              demographic_id={props?.demographic_id}
              setSyncUsers={setSyncUsers}
              usersync={usersync}
            />
          );
        }
      }

      return '';
    };

    const normalizeType = (type: any) => {
      return type ? type.toLowerCase().replace(/\s/g, '') : type;
    };

    const getDynamicUI = Array.isArray(selectedTabData?.sub_sections)
      ? selectedTabData?.sub_sections.find(
          (obj: any) => obj && obj[normalizeType(specimen_type)]
        )
      : null;

    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          overflow: 'hidden'
        }}>
        <SubTabsComponentLMS
          selectedTab={currentTab}
          routesData={filteredColList}
          action={handleTabChange}
          initialTab={currentTab || filteredColList?.[0]?.name}
          specimen_number_id={props?.specimen_number_id}
          specimen_number={props?.specimen_number}
          specimenType={specimen_type}
          procedure_id={props?.procedure_id}
          procedure_type={procedure_type}
          demographic_id={props?.demographic_id}
          {...row}
        />
        {subSectionsData?.add_button_required &&
          renderAddNewButton(
            !currentTab || currentTab === FormConstants.PURGE_TERMS.PURGE
              ? t('PRIVATE.PURGE.ADD_NEW', {
                  ns: 'private'
                })
              : t('PRIVATE.PURGE.ADD_LEGAL_HOLD', {
                  ns: 'private'
                })
          )}
        {module === FormConstants.MODULE.COURSE_CATALOG &&
        lmstype !== 'view' &&
        currentTab === 'notes' ? (
          renderAddCMSButton(
            t('Add Notes', {
              ns: 'private'
            })
          )
        ) : currentTab === 'discussion' && lmstype !== 'view' ? (
          renderAddCMSButton(
            t('Discussion', {
              ns: 'private'
            })
          )
        ) : currentTab === 'module' && lmstype !== 'view' ? (
          <>
            <AddCMSButtonDiv>
              <div>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  color="info"
                  sx={
                    {
                      // borderTopRightRadius: 'inherit !important', // Adjust border radius
                      // borderBottomRightRadius: 'inherit !important', // Adjust border radius
                      // borderTopLeftRadius: 'inherit !important', // Adjust border radius
                      // borderBottomLeftRadius: 'inherit !important',
                    }
                  }
                  onClick={() => {
                    if (
                      handleAddNewCMSRecord &&
                      typeof handleAddNewCMSRecord === 'function'
                    ) {
                      handleAddNewCMSRecord('Add module', 'module');
                    }
                  }}>
                  Add Module
                </LoadingButton>
                {/* <LoadingButton
                  type="submit"
                  variant="contained"
                  color="info"
                  onClick={popover.onOpen}
                  sx={{
                    borderTopLeftRadius: 'inherit !important', // Adjust border radius
                    borderBottomLeftRadius: 'inherit !important', // Adjust border radius
                    minHeight: '36px',
                    minWidth: 'auto'
                  }}>
                  <Iconify
                    width={16}
                    icon={
                      popover.open
                        ? 'eva:arrow-ios-upward-fill'
                        : 'eva:arrow-ios-downward-fill'
                    }
                    sx={{ml: 0.5}}
                  />
                </LoadingButton> */}
              </div>
              <Popover
                id="module"
                open={Boolean(popover.open)}
                onClose={popover.onClose}
                anchorEl={popover.open}
                anchorOrigin={anchorOrigin as PopoverOrigin}
                transformOrigin={transformOrigin as PopoverOrigin}
                slotProps={{
                  paper: {
                    sx: {
                      width: 140,
                      overflow: 'inherit',
                      ...style,
                      [`& .${menuItemClasses.root}`]: {
                        '& svg': {
                          mr: 2,
                          flexShrink: 0
                        }
                      }
                    }
                  }
                }}>
                {<StyledArrow arrow={'top-right'} />}
                <MenuItem
                  key="import"
                  onClick={() => {
                    if (
                      handleAddNewCMSRecord &&
                      typeof handleAddNewCMSRecord === 'function'
                    ) {
                      popover.onClose();
                      handleAddNewCMSRecord('Import', 'module');
                    }
                  }}>
                  Import
                </MenuItem>
              </Popover>
            </AddCMSButtonDiv>
          </>
        ) : null}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end'
          }}>
          {applicationName === 'LMS' &&
            module === FormConstants.MODULE.USER_ACCESS &&
            (!currentTab || currentTab === FormConstants.SCREENS.USERS) &&
            IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED === true &&
            renderSyncUsers(
              t('PRIVATE.COMMON.SYNC', {
                ns: 'private'
              })
            )}
          {selectedTabData?.type ===
            FormConstants.DATA_GRID_TYPES.USER_GROUPS &&
            applicationName === 'LMS' &&
            IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED === true &&
            renderSyncUserGroup(
              t('PRIVATE.COMMON.SYNC', {
                ns: 'private'
              })
            )}
          {module === FormConstants.MODULE.USER_ACCESS &&
            (!currentTab || currentTab === FormConstants.SCREENS.USERS) &&
            renderAddNewButton(
              t('PRIVATE.COMMON.ADD_USER', {
                ns: 'private'
              })
            )}
        </div>
        <div
          style={{
            overflow: 'auto',
            flex: 1
          }}>
          {selectedTabData?.is_tabs_included ? (
            <ModuleSearchPage
              uiFieldsData={selectedTabData}
              module={props?.module}
              sub_module={props?.sub_module}
              user_access_module={props?.user_access_module}
              menuItem={searchParams ? menuItem : ''}
              interface={true}
            />
          ) : null}

          {selectedTabData?.type === FormConstants.DATA_GRID_TYPES.DYNAMIC_UI &&
            specimen_type && (
              // eslint-disable-next-line react/jsx-no-useless-fragment
              <>
                {getDynamicUI &&
                getDynamicUI[normalizeType(specimen_type)]?.isLabel ? (
                  renderSelectedTabData(
                    getDynamicUI[normalizeType(specimen_type)]
                  )
                ) : (
                  <h1>
                    {getDynamicUI &&
                      getDynamicUI[normalizeType(specimen_type)]?.label}
                  </h1>
                )}
              </>
            )}

          {selectedTabData?.type === FormConstants.DATA_GRID_TYPES.CARD
            ? renderCard(selectedTabData)
            : renderSelectedTabInfo(selectedTabData?.type)}

          {Array.isArray(selectedTabData?.sub_sections) &&
          selectedTabData?.sub_sections.length > 0
            ? selectedTabData?.sub_sections.map((item: any) =>
                renderSelectedTabData(item)
              )
            : selectedTabData?.sub_sections &&
                Object.values(selectedTabData?.sub_sections).length > 0
              ? renderSelectedTabData(selectedTabData?.sub_sections)
              : null}
        </div>
      </div>
    );
  };

  const renderClinicalNewReport = (): React.ReactElement => {
    return (
      <ClinicalNewReport
        currentTab={tabsSubSecData?.name}
        subModuleUIData={sectionUIData}
        subModuleData={sectionRowsData}
        module={props?.module}
        sub_module={props?.sub_module}
        patient_id={props?.patient_id}
        legacyApp={props?.legacyApp}
        unique_id={props?.unique_id}
        handleGenerateReportBtn={() => handleGenerateReportBtn()}
        selectedTabData={tabsSubSecData}
      />
    );
  };

  const renderClinicalDocumentView = (): React.ReactElement => {
    return (
      <Grid>
        <ClinicalDocumentContainerGrid>
          <ClinicalDocumentWrapperGrid>
            <ClinicalReportDocument
              subModuleUIData={tabsSubSecData}
              subModuleData={[]}
              module={props?.module}
              sub_module={props?.sub_module}
              patient_id={props?.patient_id}
              legacyApp={props?.legacyApp}
              unique_id={props?.unique_id}
              selectedDropdownValue={selectedDropdownValue}
              isConfirmed={isConfirmed}
              setIsConfirmed={setIsConfirmed}
            />
          </ClinicalDocumentWrapperGrid>
        </ClinicalDocumentContainerGrid>
      </Grid>
    );
  };

  const renderClinicalDicomView = (): React.ReactElement => {
    return (
      <Grid>
        <ClinicalDocumentContainerGrid>
          <ClinicalDocumentWrapperGrid>
            <ClinicalReportDicom
              subModuleUIData={tabsSubSecData}
              subModuleData={[]}
              module={props?.module}
              sub_module={props?.sub_module}
              patient_id={props?.patient_id}
              legacyApp={props?.legacyApp}
              unique_id={props?.unique_id}
            />
          </ClinicalDocumentWrapperGrid>
        </ClinicalDocumentContainerGrid>
      </Grid>
    );
  };

  const renderContentByTabName = (
    tabName: string | undefined
  ): React.ReactElement | null => {
    switch (tabName) {
      case 'new_report':
      case 'custom_reports':
        return renderClinicalNewReport();

      case 'document_viewer_clinical':
        return renderClinicalDocumentView();

      case 'dicom_viewer_clinical':
        return renderClinicalDicomView();

      default:
        return null;
    }
  };

  return isLoading ? (
    <Stack
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      minHeight={'80vh'}>
      <LoadingScreen />
    </Stack>
  ) : (
    <>
      {openIsBHDialog ? (
        <IsBHDialog
          module={props?.module}
          submodule={props?.sub_module}
          showDialog={true}
          setShowDialog={setOpenIsBHDialog}
          triggerFunction={
            triggerFunction == 'download'
              ? handleDownloadDocuments
              : handleRegenerateDocuments
          }
          disableIsBHSave={triggerFunction == 'download'}
        />
      ) : null}
      <div>{renderTabs(sectionUIData, sectionRowsData)} </div>

      {tabsSubSecData?.type ===
        FormConstants.PAGE_SECTION_TYPES.SEARCH_FORM_TYPE && (
        <div style={{height: 'auto'}}>
          <ModuleSearchPage
            uiFieldsData={tabsSubSecData.search_form}
            module={props?.module}
            sub_module={props?.sub_module}
            menuItem={searchParams ? menuItem : ''}
            interface={true}
          />
        </div>
      )}
      {renderContentByTabName(tabsSubSecData?.name)}
    </>
  );
};

export default TabsComponentLMS;

